// @flow
import { call, put, select } from 'redux-saga/effects';
import i18n from 'i18next';

import {
  deleteLicence as deleteAction,
  getPlans,
  newLicenceFailure,
  newLicenceSuccess,
  newTrial,
  updateLicence as updateAction,
} from '../../actions/account/licence';
import { redirectTo } from '../../actions/session';
import { WholeState } from '../../reducers';

import { analytics } from '../../firebase';
import * as segment from '../../utils/segment';
import { getPlanType } from '../../utils/status';
import { getStripePlan, licences } from '../../services/api/saas';
import { triggerOrgTrial } from '../../services/api/subscription';
import LocalStorage, { STORAGE_KEYS } from '../../services/localStorage';

const getLicence = (state: WholeState, id: string) =>
  state.account.licence.licences ? state.account.licence.licences.find(el => el.id === id) : null;
const getParseObjectId = (state: WholeState) => state.account.user?.user?.parse?.objectId;
const getOffer = (state: WholeState, id: string) =>
  state.account.licence.offers ? state.account.licence.offers.find(el => el.id === id) : null;
const getPlan = (state: WholeState, id: string) =>
  state.account.licence.plans ? state.account.licence.plans.find(el => el.id === id) : null;

// $FlowFixMe
export function* startTrial({ payload }: Object) {
  try {
    const role = window.localStorage.getItem('account_role');
    let type: string;

    switch (payload.type) {
      case 'hr':
      case 'edu':
        type = 'Pro';
        break;
      case 'worship':
        type = 'Welcome';
        break;
      default:
        type = 'Free';
        break;
    }

    const avaId = window.localStorage.getItem('avaId');
    const { firebaseAuthUID } = yield select((state: WholeState) => ({
      firebaseAuthUID: state.scribeSession.captioner?.firebaseAuthUID,
    }));
    yield call(triggerOrgTrial, avaId, firebaseAuthUID);

    if (role === 'admin') {
      yield put(newTrial.success());
      yield put(redirectTo({ pathname: '/account/dashboard' }));
    } else {
      yield window.open('/', '_self');
    }
  } catch (error) {
    yield put(newTrial.failure(error));
  }
}

// $FlowFixMe
export function* updateLicence({ payload }: Object) {
  try {
    const licence = yield select(getLicence, payload.id);
    const licenceWithRecipient = {
      ...licence,
      recipient: { email: payload.email },
    };
    const { language } = i18n;

    const data = {
      id: payload.id,
      licence,
      recipient: { email: payload.email },
      language,
    };
    const res = yield call(licences.updateLicence, data);
    const offer = yield select(getOffer, res.data.offerId);
    const period = offer?.interval && `${offer.interval}ly`;
    yield call(segment.track, 'License Assigned', {
      'Assignee Email': res.data.recipient.email,
      'Assignee License Period': period.charAt(0).toUpperCase() + period.slice(1),
      'Assignee License Type': offer?.metadata?.category,
    });

    yield put(updateAction.success(res.data));
  } catch (err) {
    yield put(
      updateAction.failure({
        licenceId: payload.id,
        response: err.response,
      })
    );
  }
}

// $FlowFixMe
export function* postLicence({ payload }: Object) {
  try {
    const { language } = i18n;
    const trial = window.localStorage.getItem('account_trial') || 15;
    const plan = yield select(getPlan, payload.planId);
    const period = plan?.interval && `${plan.interval}ly`;

    const data = {
      licence: payload,
      language,
      trial,
    };
    const res = yield call(licences.createLicence, data);
    yield put(newLicenceSuccess(res.data.licences));

    yield call(segment.track, 'License Purchased', {
      'License Count': payload.quantity,
      'License Period': period.charAt(0).toUpperCase() + period.slice(1),
      'License Total Payment': (plan.amount / 100) * payload.quantity,
      'License Type': plan?.metadata?.category,
    });

    yield put(redirectTo({ pathname: '/account/payment-succeed' }));
  } catch (err) {
    yield put(newLicenceFailure(err.response.data));
  }
}

// $FlowFixMe
export function* fetchPlan({ payload }: Object) {
  try {
    const { language } = i18n;
    const { id } = payload;

    const res = yield call(getStripePlan, { id, language });
    yield put(getPlans.success(res.data));
  } catch (err) {
    yield put(getPlans.failure(err.response));
  }
}

// $FlowFixMe
export function* deleteLicense({ payload }: Object) {
  try {
    const { language } = i18n;

    const data = {
      licence: payload,
      language,
    };
    const res = yield call(licences.deleteLicence, data);

    yield put(deleteAction.success({ ...payload, res }));
  } catch (err) {
    yield put(deleteAction.failure(err.response));
  }
}

// $FlowFixMe
export function* openCancelLicenceTypeform() {
  const { email, org, subscription } = yield select((state: WholeState) => ({
    email: state.account.user.user.email,
    org: state.account.user.user.organization,
    subscription: state.scribeSession.subscription,
  }));
  const language = (i18n.language || 'en').split('-')[0];
  const url = `https://ava-me.typeform.com/to/${language === 'fr' ? 'r93HRx' : 'XM4hzr'}?mkt=${
    org.type
  }&email=${email}&orgname=${org.name}&med=acc#userid=${LocalStorage.get(STORAGE_KEYS.AVA_ID) || ''}`;
  analytics.logEvent('app_submitted_typeform', {
    channel: 'inbound',
    source: 'cancel-license',
    market: org.type,
    organization_name: org.name,
    plan: getPlanType(subscription),
  });
  window.open(url, '_blank');
}
